module.exports = __webpack_public_path__ + "static/media/midwestjs-perf-optimized.d11f507b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/98-demo/images/midwestjs-perf-optimized.jpg
// module id = 977
// module chunks = 0